@if (!simplified && (loading || entries?.length)) { <h3 class="text-mobile-m" [ngClass]="loading ? 'color-transparent loading-animate width-min-content' : 'color-title-grey'">{{ title || 'Historie:' }}</h3> }
@if (loading) { <span class="am-flex width-full height-36 mt-s loading-animate"></span> }
@else if (entries?.length) {
  <history-box-item [entry]="entries[0]"
                    [simplified]="simplified"
                    [photoTn]="photoTn"
                    (callback)="entries[0].callback && entries[0].callback()"
                    [class.operatable]="!readOnly && entries[0].callback"
                    [showToggler]="entries.length > 1"
                    [boxOpen]="boxOpen"
                    (toggleBox)="toggleBox($event)">
  </history-box-item>
  @if (entries.length > 1) {
    <div class="am-flex-column history-box-overflow" [class.collapsed]="boxOpen">
      @for (entry of entries.slice(1); track entry) {
        <history-box-item [entry]="entry"
                          [photoTn]="photoTn"
                          (callback)="entry.callback && entry.callback()"
                          [class.operatable]="!readOnly && entry.callback">
        </history-box-item>
      }
    </div>
  }
}
